import React from 'react';
import LastOperations from 'app/components/LastOperations';
import { Box } from '@mui/material';
import PageHeader from 'app/components/PageHeader';

const LastOperationsPage = () => {
  return (
    <Box>
      <PageHeader pageName={'Tarixçə'} />
      <LastOperations bg={true} homePage={false} />
    </Box>
  );
};

export default LastOperationsPage;
